<template>
    <v-autocomplete
        v-model="newMonster"
        :loading="searchInProgress"
        :items="sortedMonsters"
        item-text="name"
        item-value="keyId"
        :label="label"
        outlined
        no-filter
        return-object
        dense
        clearable
        hide-no-data
        v-bind="$props"
        autocomplete="off"
        :search-input.sync="searchValue"
        @change="returnValue"
    >
        <template v-slot:item="{ item }">
            <template>
                <v-list-item-content> {{ item.name }} | {{ item.section }} | {{ item.source }} </v-list-item-content>
            </template>
        </template>
    </v-autocomplete>
</template>
<script lang="js">
import { debounce, orderBy } from 'lodash'
import api from '@/api'
export default {
    name: 'MonsterLookup',
    props: {
        label: {
            type: String,
            required: false,
            default: 'Search for Monster...',
        },
        plotId: {
            type: [String,Number],
            required: false,
            default: null,
        },
    },
    data() {
        return {
            newMonster: null,
            searchValue: null,
            monsters: [],
            plotMonsters: [],
            searchDelay: 400,
            searchInProgress: false,
            lastSearchValue: null,
        }
    },
    computed: {
        sortedMonsters() {
            if (!this.searchValue) {
                return orderBy(this.plotMonsters, ['name'])
            }
            return orderBy(this.monsters.map(x => {
                if (!x) return
                x.matchIndex = x.name.toLowerCase().indexOf(this.searchValue)
                return x
            }), ['matchIndex', 'name'])
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.setupSearchWatches()
        })
    },
    watch: {
        plotId() {
            this.getPlotMonsters()
        },
    },
    methods: {
        returnValue(val) {
            this.clearSearchWatches()
            if (val) {
                this.newMonster = val
                this.$emit('input', this.newMonster)
                this.$emit('selected', this.newMonster)
                this.$emit('changed', this.newMonster)
                this.monsters = [this.newMonster]
            } else {
                this.newMonster = null
                this.$emit('input', null)
                this.$emit('cleared', null)
                this.$emit('changed', null)
                this.monsters = []
            }
            // setTimeout(() => {
            //     this.searchValue = null
            //     this.monsters = []
            // }, 200)
            setTimeout(() => this.setupSearchWatches(), 300)
        },
        setupSearchWatches() {
            this.watchSearchValue = this.$watch(
                function() {
                    return this.searchValue
                },
                debounce(function(val) {
                    if (!val || !val.length ) {
                        this.monsters = []
                        this.searchValue = null
                        this.returnValue(null)
                        return
                    }
                    if (val.length < 3) return

                    this.searchInProgress = true
                    this.lastSearchValue = val

                    api.get(`/monsters?searchterm=${encodeURI(val)}`)
                        .then(res => {
                            if (this.lastSearchValue === val) {
                                this.monsters = res
                            }
                        })
                        .finally(() => {
                            this.searchInProgress = false
                        })
                }, this.searchDelay),
            )
        },
        clearSearchWatches() {
            if (this.watchSearchValue) {
                this.watchSearchValue()
            }
        },
        clear() {
            this.monsters = []
            this.searchValue = null
        },
        getPlotMonsters() {
            if (!this.plotId) return
            this.searchInProgress = true
            api.get(`plots/${this.plotId}/monsters`)
                .then(res => {
                    this.plotMonsters = res
                })
                .finally(() => {
                    this.searchInProgress = false
                })
        },
    },
}
</script>
